import { render } from "./Styleguide.vue?vue&type=template&id=30ea6e29"
import script from "./Styleguide.vue?vue&type=script&lang=js"
export * from "./Styleguide.vue?vue&type=script&lang=js"

import "./Styleguide.vue?vue&type=style&index=0&id=30ea6e29&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__